import React from 'react';
import {SignUpComponent as SignUp} from '../../components/sign-up/sing-up.component';

export const SignUpPage = () => {
    const signUp = () => {};

    return <SignUp signUp={signUp} />;
};
